<template>
	<div class="flex flex-col items-center">
		<div class="text-sm text-base-content-light mb-1">
			<label v-if="modelValue">{{ modelValue.nameTranslationKey ? $t(modelValue.nameTranslationKey) : modelValue.name }}</label>
			<label class="italic" v-else>{{ $t('Choose level') }}</label>
		</div>
		<div class="flex items-center justify-center gap-4 border p-2 rounded-full">
			<template v-for="level in evaluationLevelsStore.items" :key="level.id">
				<button type="button"
					class="w-12 h-12 rounded-full hover:scale-110 transition-transform outline-offset-4"
					:style="{ backgroundColor: level.color, outlineColor: level.color }"
					:class="[
						modelValue && modelValue.id !== level.id ? 'opacity-20 scale-75' : '',
						modelValue && modelValue.id === level.id ? 'scale-110' : '',
						highlightedLevel && highlightedLevel.color === level.color && !modelValue ? 'outline' : '',
					]"
					:title="level.nameTranslationKey ? $t(level.nameTranslationKey) : level.name"
					@click="$emit('update:modelValue', level)"
				></button>
			</template>
		</div>
	</div>
</template>

<script lang="ts">
import { PropType } from "vue";
import { mapStores } from "pinia";
import { useEvaluationLevelsStore } from "@/stores/EvaluationLevels.store";
import { EvaluationLevel } from "@/models/EvaluationLevel.model";

/**
 * The row of coloured evaluation-level circles. Shared by the single and the bulk
 * evaluation editors so both always look and behave the same.
 */
export default {
	props: {
		modelValue: {
			type: Object as PropType<EvaluationLevel | null>,
			default: null,
		},
		/** Level to outline while nothing is chosen yet (the pupil's most recent evaluation). */
		highlightedLevel: {
			type: Object as PropType<EvaluationLevel | null>,
			default: null,
		},
	},

	emits: ['update:modelValue'],

	computed: {
		...mapStores(useEvaluationLevelsStore),
	},
}
</script>
